import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { Newspaper, CalendarDays, Megaphone } from "lucide-react";
import { Seo } from "../components/site/Seo";

const PLACEHOLDERS = [
  { Icon: Megaphone, tag: "Announcements", title: "MST Network Updates", text: "Official announcements from MST leadership will be published here." },
  { Icon: CalendarDays, tag: "Events", title: "Private Events & Masterclasses", text: "Upcoming MST events, masterclasses, and member gatherings will appear here." },
  { Icon: Newspaper, tag: "Insights", title: "Business & Wealth Insights", text: "Articles and insights on building multiple streams of income are on the way." },
];

export default function News() {
  return (
    <main data-testid="news-page">
      <Seo
        title="News & Announcements | MST — Multiple Stream Team"
        description="Official news, announcements, events, and insights from the MST network."
        path="/news"
      />
      <PageHero
        label="News"
        title={<>MST News &amp; <span className="text-[#009BFF]">Announcements</span></>}
        text="Stories, updates, and announcements from the MST network."
      />
      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Reveal className="text-center">
            <span
              className="inline-block rounded-full border border-[#006FD6]/30 bg-[#006FD6]/5 px-6 py-2 text-xs font-extrabold uppercase tracking-[0.25em] text-[#006FD6]"
              style={{ fontFamily: "var(--font-heading)" }}
              data-testid="news-coming-soon-badge"
            >
              Coming Soon
            </span>
          </Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
            {PLACEHOLDERS.map(({ Icon, tag, title, text }, i) => (
              <Reveal key={title} delay={i * 0.1} data-testid={`news-card-${i}`} className="rounded-2xl border border-[#062541]/10 bg-[#F6F8FA] overflow-hidden">
                <div className="h-44 bg-gradient-to-br from-[#062541] to-[#041525] flex items-center justify-center">
                  <Icon size={40} strokeWidth={1} className="text-[#009BFF]/60" />
                </div>
                <div className="p-8">
                  <span className="text-[11px] font-extrabold uppercase tracking-widest text-[#006FD6]" style={{ fontFamily: "var(--font-heading)" }}>{tag}</span>
                  <h3 className="mt-3 text-lg font-extrabold text-[#041525]" style={{ fontFamily: "var(--font-heading)" }}>{title}</h3>
                  <p className="mt-3 text-sm text-[#6B7280] leading-relaxed">{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
